import HeaderProgress from "@components/Progress/HeaderProgress";
import React from "react";
import { ReactComponent as MailIcon } from "@assets/icons/mail.svg";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import SectionHeaderTitle from "@components/Section/SectionHeaderTitle";
import PennyInput from "@components/Inputs/PennyInput";
import CardInformation from "@components/Cards/CardInformation";
import { Link } from "react-router-dom";
import BottomBar from "@components/BottomBars/BottomBar";

type SaveQuoteStepProps = {};

const SaveQuoteStep: React.FC<SaveQuoteStepProps> = () => {
  return (
    <section className="grow flex items-start justify-start md:items-center md:justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[846px] w-full md:rounded-3xl md:border md:border-pn_gray-200">
        <HeaderProgress currentStep={2} totalSteps={2} />

        <div className="pt-6 px-6 isolate pb-2 flex items-center">
          <div className="rounded-full bg-pn_gray-lush flex items-center justify-center w-[80px] h-[80px]">
            <MailIcon width={40} height={40} />
          </div>
          <div className="w-[80px] h-[80px] -z-10 -translate-x-6 bg-[#F4E34E] flex items-center justify-center rounded-full">
            <PennyIcon width={32} height={36} />
          </div>
        </div>

        <SectionHeaderTitle
          label="Save quote"
          description="Keep the quote Penny calculated based on your information by adding your email below."
        />

        <div className="py-4 px-4 mt-[18px] flex flex-col gap-y-4">
          <PennyInput label="Email Address" placeholder="Enter email address" />

          <CardInformation
            variant="safe"
            description={
              <div className="text-callout-regular">
                Your information is always safe with Penny.{" "}
                <Link
                  to="#"
                  className="text-pn-callout-link text-pn_cyan-500 !font-semibold"
                >
                  Learn more about how we do it.
                </Link>
              </div>
            }
          />

          <div className="mt-6">
            <BottomBar
              borderSpacing
              layout="stacked_back"
              padding={false}
              bordered={true}
              onNext={"/pension-calculator/calculator"}
              labelNext="Send"
              onBack={"/pension-calculator/calculator"}
              labelBack="Back"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default SaveQuoteStep;
